import { Box, styled } from '@mui/material';

export const Content = styled(Box)`
  width: 96%;
  height: 100%;
  margin-left: 2%;
  transition: ease-in 100ms;
`;
